import { render, staticRenderFns } from "./UserMemoTable.vue?vue&type=template&id=4c83e9af&scoped=true"
import script from "./UserMemoTable.vue?vue&type=script&lang=ts"
export * from "./UserMemoTable.vue?vue&type=script&lang=ts"
import style0 from "./UserMemoTable.vue?vue&type=style&index=0&id=4c83e9af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83e9af",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/user-search-result.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fusers%2FUserMemoTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports